import { Skeleton } from "@/shared/ui/skeleton"

/** Заглушка блока редактора: заголовок с пояснением и поле на всю высоту блока. */
function SectionSkeleton({ height }: { height: number }) {
	return (
		<div className="rounded-2xl border border-border bg-card p-5 sm:p-6" style={{ height }}>
			<div className="flex h-6 items-center">
				<Skeleton className="h-4 w-40 rounded" />
			</div>
			<div className="mt-1 flex h-[19px] items-center">
				<Skeleton className="h-3.5 w-72 max-w-full rounded" />
			</div>
			<Skeleton className="mt-5 h-[calc(100%-84px)] w-full rounded-xl" />
		</div>
	)
}

/**
 * Заглушка редактора материала по его раскладке: липкая шапка с кнопками, блоки слева
 * той же высоты, что у типичного материала, предпросмотр и готовность справа.
 */
export function EditorSkeleton() {
	return (
		<div aria-hidden="true">
			<div className="border-b border-border">
				<div className="container mx-auto flex max-w-6xl items-center gap-3 px-3 py-3 sm:px-6">
					<Skeleton className="size-12 shrink-0 rounded-xl" />
					<div className="min-w-0 flex-1">
						<div className="flex h-[16.5px] items-center">
							<Skeleton className="h-3 w-24 rounded" />
						</div>
						<div className="flex h-7 items-center">
							<Skeleton className="h-4 w-56 rounded" />
						</div>
					</div>
					<Skeleton className="hidden h-12 w-24 rounded-xl sm:block" />
					<Skeleton className="h-12 w-32 rounded-xl" />
				</div>
			</div>
			<div className="container mx-auto grid max-w-6xl items-start gap-6 px-3 py-6 sm:px-6 lg:grid-cols-[minmax(0,1fr)_360px] lg:py-8">
				<div className="min-w-0 space-y-5">
					{[802, 367, 258, 340].map((height) => (
						<SectionSkeleton key={height} height={height} />
					))}
				</div>
				<div className="space-y-4">
					<SectionSkeleton height={156} />
					<SectionSkeleton height={250} />
				</div>
			</div>
		</div>
	)
}
